<template>
  <div class="pos-rel">
    <input
      class="input-text w-x50"
      placeholder="Monster Name"
      v-model="searchQuery"
      @focus="onFocus"
      @blur="onBlur"
      @keyup.enter="onEnter"
      @keyup.up="navigate(-1)"
      @keyup.down="navigate(1)"
    >
    <div
      v-if="showMenu"
      class="monster-search-menu"
    >
      <div v-if="searchQuery.trim().length">
        <div
          v-for="(monster, index) in filteredMonsters"
          :class="`monster-item ${index === activeIndex ? 'focused' : ''}`"
          @mouseenter="activeIndex = index"
          @mouseleave="activeIndex = -1"
          @click="selectMonster(monster)"
        >
          <div class="t">{{ monster.name }}</div>
        </div>
      </div>
      <div v-else class="t dark-gray">[no results found]</div>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue';
  import { useCombatEncounterStore } from '../../stores/combat_encounter_store';

  const store = useCombatEncounterStore();

  const searchQuery = ref('');
  
  const filteredMonsters = computed(() => {
    return store.undetailedMonsters.filter((monster) => {
      return monster.name.toLowerCase().includes(searchQuery.value.toLowerCase().trim());
    })
  });
  
  // Monster Selecting
  const onEnter = () => {
    const monster = filteredMonsters.value[activeIndex.value];
    if (monster) selectMonster(monster);
  }
  const selectMonster = (monster) => {
    store.fetchDetailedMonster(monster);
    searchQuery.value = '';
  };
  
  // Menu Focusing
  const showMenu = ref(false);
  const onFocus = () => {
    showMenu.value = true;
  }
  const onBlur = () => {
    setTimeout(() => {
      showMenu.value = false;
      activeIndex.value = 0;
    }, 100);
  };
  
  // Menu Navigating
  const activeIndex = ref(0);
  const indexInBounds = (index) => { return index >= 0 || index <= filteredMonsters.value.length - 1 };
  const navigate = (dir) => {
    console.log(activeIndex.value, indexInBounds(activeIndex.value));
    if (indexInBounds(activeIndex.value)) {
      const newIndex = activeIndex.value + dir;
      if (indexInBounds(newIndex)) activeIndex.value = newIndex;
    } else {
      activeIndex.value = dir === -1 ? 0 : filteredMonsters.value.length - 1;
    }
  }
</script>